(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blz-tratamento"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[id^="blz-tratamentos-"]');
  const toast = document.getElementById('blz-trat-toast');
  const toastMsg = document.getElementById('blz-trat-toast-msg');
  let toastTimer;

  function showToast(msg) {
    toastMsg.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  sections.forEach(function (section) {

    /* ── Tabs drag (mouse desktop) ── */
    var tabsEl = section.querySelector('.blz-trat__tabs');
    if (tabsEl) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      tabsEl.addEventListener('mousedown', function (e) {
        isDown = true;
        tabsEl.style.cursor = 'grabbing';
        startX = e.pageX - tabsEl.offsetLeft;
        scrollLeft = tabsEl.scrollLeft;
      });
      tabsEl.addEventListener('mouseleave', function () {
        isDown = false;
        tabsEl.style.cursor = '';
      });
      tabsEl.addEventListener('mouseup', function () {
        isDown = false;
        tabsEl.style.cursor = '';
      });
      tabsEl.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - tabsEl.offsetLeft;
        var walk = (x - startX) * 1.5;
        tabsEl.scrollLeft = scrollLeft - walk;
      });
    }

    /* ── Tabs click ── */
    var tabsDragged = false;
    if (tabsEl) {
      tabsEl.addEventListener('mousedown', function () { tabsDragged = false; });
      tabsEl.addEventListener('mousemove', function () { tabsDragged = true; });
    }

    var tabs = section.querySelectorAll('.blz-trat__tab');
    var panels = section.querySelectorAll('.blz-trat__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tabsDragged) return;
        var idx = this.dataset.tab;

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        var panel = section.querySelector('[data-panel="' + idx + '"]');
        if (panel) {
          panel.classList.add('is-active');
          var track = panel.querySelector('.blz-trat__track');
          if (track) track.style.transform = 'translateX(0)';
          initSlider(panel);
        }
      });
    });

    /* ── Init todos os sliders ── */
    panels.forEach(function (panel) {
      if (panel.classList.contains('is-active')) initSlider(panel);
    });

    function initSlider(panel) {
      if (panel.blzRefreshSlider) {
        panel.blzRefreshSlider();
        return;
      }
      var track = panel.querySelector('.blz-trat__track');
      var outer = panel.querySelector('.blz-trat__track-outer');
      var btnPrev = panel.querySelector('.blz-trat__arrow--prev');
      var btnNext = panel.querySelector('.blz-trat__arrow--next');
      if (!track || !outer) return;

      var cards = track.querySelectorAll('.blz-trat__card');
      if (!cards.length) return;

      var currentOffset = 0;
      var maxOffset = 0;

      function calcMax() {
        maxOffset = track.scrollWidth - outer.offsetWidth;
        if (maxOffset < 0) maxOffset = 0;
      }

      function updateArrows() {
        if (btnPrev) btnPrev.disabled = currentOffset <= 0;
        if (btnNext) btnNext.disabled = currentOffset >= maxOffset;
      }

      function slideTo(offset) {
        currentOffset = Math.max(0, Math.min(offset, maxOffset));
        track.style.transform = 'translateX(-' + currentOffset + 'px)';
        updateArrows();
      }

      calcMax();
      updateArrows();

      function getStep() {
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return (cards[0].getBoundingClientRect().width + gap) * 2;
      }

      if (btnPrev) {
        btnPrev.addEventListener('click', function () { slideTo(currentOffset - getStep()); });
      }
      if (btnNext) {
        btnNext.addEventListener('click', function () { slideTo(currentOffset + getStep()); });
      }

      panel.blzRefreshSlider = function () {
        outer.scrollLeft = 0;
        calcMax();
        slideTo(0);
      };
      window.addEventListener('resize', panel.blzRefreshSlider, { passive: true });

      /* Touch / drag */
      var startX = 0;
      var isDragging = false;

      outer.addEventListener('touchstart', function (e) { if (window.innerWidth <= 480) return; startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
      outer.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) slideTo(currentOffset + diff);
      }, { passive: true });
      outer.addEventListener('mousedown', function (e) { if (window.innerWidth <= 480) return; startX = e.clientX; isDragging = true; });
      window.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        var diff = startX - e.clientX;
        if (Math.abs(diff) > 40) slideTo(currentOffset + diff);
      });
    }

    /* Product forms use the shared cart drawer submit handler. */
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
